import { useEffect, useState, type FormEvent } from 'react'
import { referralsService, type PortalReferral } from '@/services/referralsService'
import { extractApiError } from '@/utils/extractApiError'

const EMPTY = {
  nome: '',
  empresa: '',
  telefone: '',
  email: '',
  site: '',
  observacao: '',
}

export function useParceirosLeadEdit(
  row: PortalReferral | null,
  onSaved: () => Promise<void> | void,
) {
  const [values, setValues] = useState(EMPTY)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!row) return
    setValues({
      nome: row.nome ?? '',
      empresa: row.empresa ?? '',
      telefone: row.telefone ?? '',
      email: row.email ?? '',
      site: row.site ?? '',
      observacao: row.observacao ?? '',
    })
    setError('')
  }, [row])

  function patch(field: keyof typeof EMPTY, value: string) {
    setValues((prev) => ({ ...prev, [field]: value }))
  }

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (!row || !row.canEdit) return
    setSubmitting(true)
    setError('')
    try {
      await referralsService.updateMine(row.id, {
        nome: values.nome.trim(),
        empresa: values.empresa.trim(),
        telefone: values.telefone.trim() || undefined,
        email: values.email.trim() || undefined,
        site: values.site.trim() || undefined,
        observacao: values.observacao.trim() || undefined,
      })
      await onSaved()
    } catch (caught) {
      setError(extractApiError(caught, 'Não foi possível salvar o contato. Tente de novo.').message)
    } finally {
      setSubmitting(false)
    }
  }

  return { values, patch, submitting, error, submit, canEdit: Boolean(row?.canEdit) }
}
